<div class="h-100" fxLayout="column" fxLayoutAlign="space-between stretch">
  

  <div mat-dialog-title>
    <span>Preview</span>
    <span class="name-span" *ngIf="displayName != ''">: {{ displayName }}</span>
    <small class="text-info m-l-5">{{ fileName }}</small>
  </div>
  <div class="container" fxLayout="row" fxLayoutAlign="space-between center">

    <div>
      <button *ngIf="data.additionalFileNames?.length > 1" mat-icon-button class="nav-button left" (click)="previousFile()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>

    
    <div *ngIf="fileType === '.jpg' || fileType === '.png' || fileType === '.webp'" class="w-100 h-100" #imageContainer fxLayout="column" fxLayoutAlign="center center">
      <div fxLayout="row" fxLayoutAlign="center stretch"> 
        <img [src]="url" [style.maxHeight.px]="productHeight" [style.maxWidth.px]="productWidth" alt="Image preview">
      </div>
    </div>
    <div *ngIf="fileType === '.glb'" class="w-100 h-100 model-viewer-container" #modelContainer fxLayout="column" fxLayoutAlign="center center">
      <model-viewer id="glb"
        [style.height.px]="productHeight" [style.width.px]="productWidth"
        [exposure]="exposureValue"
        [shadow-intensity]="shadowIntensityValue"
        camera-controls
        touch-action="pan-y"
        [src]="url"
        [ios-src]="urlIos"
        [poster]="posterUrl"
        data-js-focus-visible=""
        ar
        ar-modes="scene-viewer webxr quick-look"
        ar-status="not-presenting"
        alt="GLB preview"
        min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
        min-field-of-view="45deg" max-field-of-view="90deg"
        environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.jpg"
        environment-image-intensity="0.35"
        camera-orbit="225deg 55deg auto"
        tone-mapping="aces">
      </model-viewer>
      <div class="model-viewer-controls" fxLayout="row" fxLayoutAlign="end center">
        <div fxLayout="row" fxLayoutAlign="end center">
          <mat-icon matTooltip="Exposure">wb_sunny</mat-icon>
          <mat-slider
            min="0"
            max="3"
            step="0.1"
            thumbLabel 
            [(ngModel)]="exposureValue"
            (input)="onExposureChange($event)"
            tickInterval="0.5">
          </mat-slider>
          <!-- <span>{{exposureValue | number: '1.1-1'}}</span> -->
        </div>
        <div *ngIf="false" fxLayout="row" fxLayoutAlign="end center">
          <mat-icon matTooltip="Shadow Intensity">brightness_6</mat-icon>
          <mat-slider
            min="0"
            max="1"
            step="0.1"
            thumbLabel 
            [(ngModel)]="shadowIntensityValue"
            (input)="onShadowIntensityChange($event)"
            tickInterval="0.1">
          </mat-slider>
          <!-- <span>{{shadowIntensityValue | number: '1.1-1'}}</span> -->
        </div>
      </div>
    </div>

    <div>
      <button *ngIf="data.additionalFileNames?.length > 1" mat-icon-button class="nav-button right" (click)="nextFile()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

</div>
